import {
  LIST_ATTENDANCES,
} from '@/data/actions/modules/financial';

export default [
  {
    path: '/financial/appointment-attendances',
    component: () => import(/* webpackChunkName: "accounts" */ './components/Attendance.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_ATTENDANCES,
    },
  },
];
